// Performance-optimized mobile-compatible script
(function() {
    'use strict';
    
    // Cache for DOM elements to avoid repeated queries
    const elementCache = new Map();
    
    // Optimized element selector with caching
    function cached$(selector) {
        if (!elementCache.has(selector)) {
            elementCache.set(selector, document.querySelector(selector));
        }
        return elementCache.get(selector);
    }
    
    function cachedAll$(selector) {
        const cacheKey = `all_${selector}`;
        if (!elementCache.has(cacheKey)) {
            elementCache.set(cacheKey, document.querySelectorAll(selector));
        }
        return elementCache.get(cacheKey);
    }

    // Optimized idle callback for better performance
    function safeIdleCallback(cb) {
        if ("requestIdleCallback" in window) {
            requestIdleCallback(cb, { timeout: 1000 });
        } else {
            // Use shorter timeout for mobile devices
            setTimeout(cb, window.innerWidth < 768 ? 100 : 200);
        }
    }

    // Phase 13 (2026-05-01): jQuery removed from theme. All callsites converted to vanilla.

    // Optimized product image slider with hardware acceleration
    function initializeProductSlider() {
        const slider = cached$(".product-image-slider");
        if (!slider) return;

        const track = slider.querySelector(".optimize-slider-track");
        const slides = track?.querySelectorAll(".optimize-slide");
        const prevBtn = slider.querySelector(".optimize-prev");
        const nextBtn = slider.querySelector(".optimize-next");
        const dots = slider.querySelectorAll(".optimize-dot");
        const heroImage = cached$(".optimize-main-product-image");

        if (!track || !slides || slides.length === 0) return;

        let currentIndex = 0;
        const totalSlides = slides.length;
        let isAnimating = false;

        // Optimize for hardware acceleration
        track.style.willChange = 'transform';
        track.style.transform = 'translateZ(0)'; // Force hardware acceleration

        // Show slider and hide hero image
        slider.classList.remove("optimize-slider-hidden");
        if (heroImage) heroImage.style.display = "none";

        // Show all slides with optimized display
        slides.forEach(slide => {
            slide.style.display = "block";
            slide.style.willChange = 'transform'; // Prepare for animations
        });

        // Optimized update function with requestAnimationFrame
        function updateSlider() {
            if (isAnimating) return;
            isAnimating = true;
            
            requestAnimationFrame(() => {
                track.style.transform = `translate3d(-${currentIndex * 100}%, 0, 0)`;
                
                // Update dots efficiently
                dots.forEach((dot, idx) => {
                    if (idx === currentIndex) {
                        dot.classList.add("active");
                    } else {
                        dot.classList.remove("active");
                    }
                });
                
                isAnimating = false;
            });
        }

        // Optimized navigation with debouncing
        let navTimeout;
        function navigate(direction) {
            if (navTimeout) return;
            navTimeout = setTimeout(() => navTimeout = null, 300);
            
            if (direction === 'next') {
                currentIndex = (currentIndex + 1) % totalSlides;
            } else {
                currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
            }
            updateSlider();
        }

        // Event listeners with passive option for better performance
        nextBtn?.addEventListener("click", () => navigate('next'), { passive: true });
        prevBtn?.addEventListener("click", () => navigate('prev'), { passive: true });

        dots.forEach(dot => {
            dot.addEventListener("click", (e) => {
                const index = parseInt(dot.getAttribute("data-index"));
                if (!isNaN(index) && index !== currentIndex) {
                    currentIndex = index;
                    updateSlider();
                }
            }, { passive: true });
        });

        // Optimized mobile touch handling
        let touchStartX = 0;
        let touchStartY = 0;
        let isSwiping = false;
        let swipeThreshold = 50;

        // Use passive listeners for better scroll performance
        track.addEventListener("touchstart", (e) => {
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
            isSwiping = true;
        }, { passive: true });

        track.addEventListener("touchmove", (e) => {
            if (!isSwiping) return;
            
            const touchX = e.touches[0].clientX;
            const touchY = e.touches[0].clientY;
            const diffX = Math.abs(touchStartX - touchX);
            const diffY = Math.abs(touchStartY - touchY);
            
            // Only prevent default if horizontal swipe is stronger
            if (diffX > diffY && diffX > 10) {
                e.preventDefault();
            }
        }, { passive: false });

        track.addEventListener("touchend", (e) => {
            if (!isSwiping) return;
            
            const touchEndX = e.changedTouches[0].clientX;
            const diffX = touchStartX - touchEndX;

            if (Math.abs(diffX) > swipeThreshold) {
                navigate(diffX > 0 ? 'next' : 'prev');
            }
            isSwiping = false;
        }, { passive: true });

        // Initialize
        updateSlider();
    }

    // Main initialization function
    function initializeScript() {
        console.log('started with code<<<<<<<<<<<<<>>>>>>>>>>>>>>');
        
        // Initialize product slider first (most critical)
        initializeProductSlider();

        // Countdown timer with optimized performance
        const timerKey = "bs_custom_bs_sale_timer_end";
        const startTimeSeconds = 18 * 3600 + 3 * 60 + 23;

        function initCountdown(duration) {
            const timerElement = cached$("#bs_custom_bs_timer");
            if (!timerElement) return;

            const now = Date.now();
            let savedEnd = null;
            
            // Safe localStorage with fallback
            try {
                savedEnd = localStorage.getItem(timerKey);
            } catch (e) {
                console.warn('localStorage unavailable');
            }
            
            let endTime = savedEnd ? parseInt(savedEnd) : now + duration * 1000;

            if (!savedEnd) {
                try {
                    localStorage.setItem(timerKey, endTime);
                } catch (e) {
                    // Silent fail for private browsing
                }
            }

            let animationId;
            function updateTimer() {
                const remaining = Math.floor((endTime - Date.now()) / 1000);
                
                if (remaining <= 0) {
                    timerElement.textContent = "00:00:00";
                    try {
                        localStorage.removeItem(timerKey);
                    } catch (e) {
                        // Silent fail
                    }
                    return;
                }

                const hrs = String(Math.floor(remaining / 3600)).padStart(2, '0');
                const mins = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
                const secs = String(remaining % 60).padStart(2, '0');

                timerElement.textContent = `${hrs}:${mins}:${secs}`;
                animationId = requestAnimationFrame(updateTimer);
            }

            updateTimer();
        }

        initCountdown(startTimeSeconds);

        // Optimized accordion functionality
        const accordionButtons = cachedAll$('.accordion-item button');
        if (accordionButtons.length > 0) {
            accordionButtons.forEach(button => {
                button.addEventListener('click', function (e) {
                    e.preventDefault();
                    accordionButtons.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
                    this.setAttribute('aria-expanded', 'true');
                }, { passive: false });
            });
        }

        // Legacy IE support (minimal impact on modern browsers)
        const ua = navigator.userAgent;
        if (ua.includes("MSIE") || ua.includes("Trident/")) {
            // IE-specific code (unchanged but optimized selectors)
            const hiddenInput = cached$('#{{ product_form_id }} input[name="id"]');
            const variantSwitcher = cached$('variant-radios[data-section="{{ section.id }}"]') || 
                                  cached$('variant-selects[data-section="{{ section.id }}"]');
            
            if (hiddenInput && variantSwitcher) {
                const noscriptWrapper = cached$('.product-form__noscript-wrapper-{{ section.id }}');
                if (noscriptWrapper) {
                    const wrapper = document.createElement('div');
                    wrapper.innerHTML = noscriptWrapper.textContent;
                    variantSwitcher.outerHTML = wrapper.outerHTML;
                    
                    const variantsElement = cached$('#Variants-{{ section.id }}');
                    if (variantsElement) {
                        variantsElement.addEventListener('change', function (e) {
                            hiddenInput.value = e.currentTarget.value;
                        });
                    }
                }
            }
        }

        // Brand A-Z scroll (collection-letter index → product anchor)
        document.querySelectorAll('.brand-wrapper-letter span').forEach((span) => {
            span.addEventListener('click', () => {
                const target = span.getAttribute('aria-label');
                if (!target) return;
                const targetElement = document.getElementById(target);
                if (targetElement) targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        });

        // Additional-information collapsible (PDP)
        document.querySelectorAll('.additional_information_bs h2').forEach((h2) => {
            h2.addEventListener('click', () => {
                const root = h2.closest('.additional_information_bs');
                if (!root) return;
                root.querySelectorAll('p, h2').forEach((el) => el.classList.toggle('active'));
            });
        });

        // Variant pill swatch (collection-card variant chips → price/discount swap)
        document.querySelectorAll('.pb-variant-options .variant').forEach((variant) => {
            variant.addEventListener('click', () => {
                const info = variant.closest('.card__information');
                const card = variant.closest('.card-wrapper');
                if (!info) return;

                requestAnimationFrame(() => {
                    info.querySelectorAll('.variant').forEach((v) => v.classList.remove('active'));
                    variant.classList.add('active');

                    const id = variant.getAttribute('id');
                    const price = variant.getAttribute('money-value');
                    const offerPrice = variant.getAttribute('offer-money');
                    const compare = variant.getAttribute('com-money-value');

                    if (id) {
                        const idInput = info.querySelector('input.product-variant-id');
                        if (idInput) idInput.value = id;
                    }
                    if (price) {
                        info.querySelectorAll('span.price-item.price-item--sale, .cartprice')
                            .forEach((el) => { el.textContent = price; });
                    }
                    if (offerPrice) {
                        const stickyB = document.querySelector('.sticky-add-to-cart-bs .sticky-cart-top b');
                        if (stickyB) stickyB.textContent = offerPrice;
                    }
                    if (compare) {
                        info.querySelectorAll('s.price-item.price-item--regular')
                            .forEach((el) => { el.textContent = compare; });

                        if (price && card) {
                            const compareNum = parseFloat(compare.replace(/[₹,]/g, ''));
                            const priceNum = parseFloat(price.replace(/[₹,]/g, ''));
                            if (compareNum > priceNum && compareNum > 0) {
                                const discount = Math.round(((compareNum - priceNum) / compareNum) * 100);
                                const discountEl = card.querySelector('.pb-discount');
                                if (discountEl) discountEl.textContent = discount + '% OFF';
                            }
                        }
                    }
                });
            });
        });

        // Optimized ShareChat SDK
        (function(w, d, s, l, i) {
            w['scSdkId'] = i;
            w[l] = w[l] || [];
            w.scq = function(e, t, p) {
                w[l].push({ 
                    eventName: e, 
                    eventType: t, 
                    meta: p || {}, 
                    eventFireTs: Date.now() 
                });
            };
            
            // Use requestIdleCallback for non-critical SDK loading
            safeIdleCallback(() => {
                w.scq("PAGE_VIEW", "AUTO", { pageUrl: w.location.href });
                
                const script = d.createElement(s);
                script.type = 'text/javascript';
                script.async = true;
                script.src = 'https://sc-events-sdk.sharechat.com/web-sdk.js';
                script.onerror = () => console.warn('ShareChat SDK failed to load');
                
                const firstScript = d.getElementsByTagName(s)[0];
                firstScript.parentNode.insertBefore(script, firstScript);
            });
        })(window, document, "script", "scLayer", "ukNy5SCivA");

        // Global checkout function
        window.openCheckout = function() {
            console.log("Sneha");
            if (typeof window.scq === 'function') {
                scq('Initiate checkout', 'pre_defined');
            }
        };
    }

    // Optimized DOM ready with faster detection
    function domReady(callback) {
        if (document.readyState === 'complete' || 
            (document.readyState === 'interactive' && document.body)) {
            setTimeout(callback, 0);
        } else {
            document.addEventListener('DOMContentLoaded', callback, { once: true });
        }
    }

    // Initialize with performance optimization
    safeIdleCallback(() => {
        domReady(initializeScript);
    });

})();

document.addEventListener("scroll", function () {
  const stickyBar = document.querySelector(".sticky-add-to-cart-bs");
  if (!stickyBar) return;

  const scrollPosition = window.innerHeight + window.scrollY; 
  const documentHeight = document.documentElement.scrollHeight;

  // If user is within 200px of the bottom → hide
  if (scrollPosition >= documentHeight - 200) {
    stickyBar.style.display = "none";
  } else {
    stickyBar.style.display = "block";
  }
});


